import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { Level } from './level';
import { ConsoleHandler } from './console-handler';
var _instances = /*#__PURE__*/_classPrivateFieldLooseKey("instances");
var _name = /*#__PURE__*/_classPrivateFieldLooseKey("name");
var _level = /*#__PURE__*/_classPrivateFieldLooseKey("level");
var _handlers = /*#__PURE__*/_classPrivateFieldLooseKey("handlers");
export class Logger {
  constructor(name) {
    Object.defineProperty(this, _name, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _level, {
      writable: true,
      value: Level.ERROR
    });
    Object.defineProperty(this, _handlers, {
      writable: true,
      value: new Set()
    });
    this.getName = () => _classPrivateFieldLooseBase(this, _name)[_name];
    this.setLevel = level => {
      _classPrivateFieldLooseBase(this, _level)[_level] = level;
    };
    this.getLevel = () => _classPrivateFieldLooseBase(this, _level)[_level];
    this.addHandler = handler => {
      if (handler.level === Level.OFF) {
        throw new Error('Cannot define log handler with level `Level.OFF`');
      }
      const hasPotentialDuplicate = Array.from(_classPrivateFieldLooseBase(this, _handlers)[_handlers]).some(hdlr => handler instanceof hdlr.constructor);
      if (hasPotentialDuplicate) {
        console.warn(`Added potentially duplicated log handler ${handler.constructor.name} to logger ${_classPrivateFieldLooseBase(this, _name)[_name]}`);
      }
      _classPrivateFieldLooseBase(this, _handlers)[_handlers].add(handler);
    };
    this.removeHandler = handler => {
      _classPrivateFieldLooseBase(this, _handlers)[_handlers].delete(handler);
    };
    this.getHandlers = () => _classPrivateFieldLooseBase(this, _handlers)[_handlers];
    this.log = (level, ...messages) => {
      if (level < _classPrivateFieldLooseBase(this, _level)[_level] || _classPrivateFieldLooseBase(this, _level)[_level] === Level.OFF) {
        return;
      }
      const record = {
        loggerName: _classPrivateFieldLooseBase(this, _name)[_name],
        level,
        messages,
        timestamp: Date.now()
      };
      const applicableHandlers = this.getHandlersByLevel(level);
      applicableHandlers.forEach(hdlr => hdlr.publish(record));
    };
    this.debug = (...args) => this.log(Level.DEBUG, ...args);
    this.info = (...args) => this.log(Level.INFO, ...args);
    this.warn = (...args) => this.log(Level.WARNING, ...args);
    this.error = (...args) => this.log(Level.ERROR, ...args);
    this.getHandlersByLevel = lookupLevel => new Set(Array.from(_classPrivateFieldLooseBase(this, _handlers)[_handlers]).filter(({
      level
    }) => level === lookupLevel || level === Level.ALL));
    _classPrivateFieldLooseBase(this, _name)[_name] = name;
  }
  static getLogger(name) {
    if (name === Logger.GLOBAL_LOGGER_NAME) {
      throw new Error('Use `Logger.getGlobal()` instead.');
    }
    if (!_classPrivateFieldLooseBase(Logger, _instances)[_instances].has(name)) {
      const logger = new Logger(name);
      _classPrivateFieldLooseBase(Logger, _instances)[_instances].set(name, logger);
      return logger;
    }
    return _classPrivateFieldLooseBase(Logger, _instances)[_instances].get(name);
  }
  static getGlobal() {
    if (!_classPrivateFieldLooseBase(Logger, _instances)[_instances].has(Logger.GLOBAL_LOGGER_NAME)) {
      const globalLogger = new Logger(Logger.GLOBAL_LOGGER_NAME);
      globalLogger.addHandler(new ConsoleHandler());
      _classPrivateFieldLooseBase(Logger, _instances)[_instances].set(Logger.GLOBAL_LOGGER_NAME, globalLogger);
    }
    return _classPrivateFieldLooseBase(Logger, _instances)[_instances].get(Logger.GLOBAL_LOGGER_NAME);
  }
}
Logger.GLOBAL_LOGGER_NAME = 'global';
Object.defineProperty(Logger, _instances, {
  writable: true,
  value: new Map()
});